import { render, staticRenderFns } from "./STLPARES-game.vue?vue&type=template&id=b3f3e116"
import script from "./STLPARES-game.vue?vue&type=script&lang=js"
export * from "./STLPARES-game.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports